// extracted by mini-css-extract-plugin
export default {"ParticlesBackground":"styles_ParticlesBackground__YD1ej"};